import routes from 'router';
import { useRoutes } from 'react-router-dom';
import { Navbar } from 'components/nav';
import {
  useDocTitle,
  useFeatureTogglingGetQuery,
  useOfflineState,
} from 'hooks';
import { NoInternetConnection } from 'components/common';
import css from './App.module.scss';
import { Spinner } from '@epam/uui-components';

export const App = () => {
  useDocTitle();
  const { isOffline } = useOfflineState();
  const content = useRoutes(routes);
  const { isLoading } = useFeatureTogglingGetQuery();

  return (
    <div className={css.app}>
      <Navbar />
      {isOffline && <NoInternetConnection />}
      {isLoading ? <Spinner cx="spinner" /> : content}
    </div>
  );
};
